<form [formGroup]="form">
  <div class="grid gap-x-4 xl:grid-cols-2">
    <app-form-control
      [floatLabel]="true"
      [underlineInputStyle]="true"
      label="Imię">
      <input
        [formControl]="form.controls.firstName"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control
      [floatLabel]="true"
      [underlineInputStyle]="true"
      label="Nazwisko">
      <input
        [formControl]="form.controls.lastName"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control
      [floatLabel]="true"
      [underlineInputStyle]="true"
      label="Numer telefonu">
      <app-phone-number-with-prefix [formControl]="form.controls.phone" />
    </app-form-control>

    <app-form-control
      [floatLabel]="true"
      [underlineInputStyle]="true"
      label="E-mail">
      <input
        [formControl]="form.controls.email"
        appPrimengInputText
        pInputText
        type="email" />
    </app-form-control>

    <app-form-control
      [floatLabel]="true"
      [underlineInputStyle]="true"
      label="Kraj">
      <p-select
        [formControl]="form.controls.countryId"
        [options]="valueOrDefault(countrySelectItems$ | async, [])"
        appPrimengSelect
        [fluid]="true" />
    </app-form-control>

    @if (stateFormControlAvailability$ | async) {
      <app-form-control
        [floatLabel]="true"
        [underlineInputStyle]="true"
        label="Region">
        <input
          [formControl]="form.controls.state"
          appPrimengInputText
          pInputText />
      </app-form-control>
    }

    <app-form-control
      [floatLabel]="true"
      [underlineInputStyle]="true"
      label="Adres">
      <input
        [formControl]="form.controls.streetLine1"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control
      [floatLabel]="true"
      [underlineInputStyle]="true"
      label="Adres cd.">
      <input
        [formControl]="form.controls.streetLine2"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control
      [floatLabel]="true"
      [underlineInputStyle]="true"
      label="Kod pocztowy">
      <input
        [formControl]="form.controls.postCode"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control
      [floatLabel]="true"
      [underlineInputStyle]="true"
      label="Miasto">
      <input
        [formControl]="form.controls.city"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control
      [floatLabel]="true"
      [underlineInputStyle]="true"
      label="Nazwa firmy">
      <input
        [formControl]="form.controls.companyName"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control
      [floatLabel]="true"
      [hint]="shippingMethodHint$ | async"
      [underlineInputStyle]="true"
      inputId="97f76260-6db7-4e79-bdff-f39b3165a4a1"
      label="Rodzaj wysyłki">
      <p-select
        [formControl]="form.controls.shippingMethodId"
        [options]="valueOrDefault(shippingMethodSelectItems$ | async, [])"
        appPrimengSelect
        [fluid]="true"
        inputId="97f76260-6db7-4e79-bdff-f39b3165a4a1">
      </p-select>
    </app-form-control>

    @if (currentCountryCode$ | async; as country) {
      @if (currentShippingMethod$ | async; as method) {
        @if (method.isInternationalInPostGeowidget) {
          <app-form-control>
            <app-in-post-point-select
              [international]="true"
              [country]="country"
              [formControl]="form.controls.shippingPoint" />
          </app-form-control>
        }

        @if (method.isDomesticInPostGeowidget) {
          <div class="col-span-2">
            <app-form-control>
              <app-in-post-point-select
                [international]="false"
                [country]="country"
                [formControl]="form.controls.shippingPoint" />
            </app-form-control>
          </div>
        }
      }
    }
  </div>

  <div class="mt-4 flex justify-end gap-4">
    @if (pending()) {
      <app-spinner-filled />
    } @else {
      <p-button
        (onClick)="handleCancelButtonClick()"
        appPrimengButton
        label="Anuluj"
        type="button"
        variant="outlined" />

      <p-button
        (onClick)="handleSubmitButtonClick()"
        [disabled]="form.invalid"
        appPrimengButton
        label="Zapisz"
        type="submit" />
    }
  </div>
</form>
